import type { AnimationsMap } from './types';

export const ANIMATIONS: AnimationsMap = {
  'Fade-in': { timeout: { enter: 150, exit: 0 } },
  Appear: { timeout: { enter: 300, exit: 300 } },
  Fade: { timeout: { enter: 100, exit: 100 } },
};
